import React, { useEffect, useRef, useState } from "react";
// import { toast } from "react-hot-toast";
import { Form } from "react-router-dom";
import axios from "../../API/axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import WarningAmberSharpIcon from "@mui/icons-material/WarningAmberSharp";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import { debounce } from "lodash";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles, wljSelectPortalProps } from "../../selectStyles";
// import { Modal } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import { resume } from "../../config/imagesLink";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Button, Overlay, Popover } from "react-bootstrap";

import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import { Portal } from "../../components/Portal";

const ProfileExperience = ({
  showUserExperience,
  // showAchievementUserExperience,
  handleCloseUserExperience,
  getUserProfile,
  userUId,
  ccvId,
  getUserCcv,
  userData
}) => {
  const { t } = useTranslation();
  useEscapeKeyDown(showUserExperience, handleCloseUserExperience);

  const sessionId = localStorage.getItem("sessionId");
  const [startDate, setStartDate] = useState(null);
  const [present, setPresent] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const isExperienceDateRangeInvalid =
    Boolean(startDate) &&
    Boolean(endDate) &&
    moment(endDate).isBefore(moment(startDate), "day");
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState("");
  const [citySearch, setCitySearch] = useState(null);
  const [showInputInsteadOfDropdown, setShowInputInsteadOfDropdown] = useState(false);

  const [display, setDisplay] = useState(false);
  const UserCcv = localStorage.getItem("UserCcv");


  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const language = localStorage.getItem("Lang");

  const [checkCurrent, setCheckCurrent] = useState('')
  console.log('checkCurrent', checkCurrent);

  const CheckCurrentExperienceStatus = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`UserData/CheckCurrentExperienceStatus`, responseData)
        .then((res) => {
          setCheckCurrent(res?.data?.responseData)
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  useEffect(() => {
    if (showUserExperience) {
      CheckCurrentExperienceStatus()
    }
  }, [showUserExperience])

  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);

  //********Location DDL Start  ********//
  const [valueLocation, setValueLocation] = useState(null);
  const [pageLocation, setPageLocation] = useState(0);
  const [typedLocation, setTypedLocation] = useState("");
  const [optionsLocation, setOptionsLocation] = useState([]);
  const [totalPagesLocation, setTotalPagesLocation] = useState(0);
  const logValueLocation = debounce((typed) => {
    setTypedLocation(typed);
  }, 250);

  const addOptionsLocation = () => {
    axios
      .get(
        `Master/GetLocalitiesDDL?search=${typedLocation}&pageNumber=${pageLocation + 1
        }&pageSize=100&LangKey=${language}`
      )
      .then((response) => {
        console.log(response);
        const data = response.data.responseData.localityList.map((item) => ({
          value: item.locationId,
          label: item.locationName,
        }));
        setPageLocation((prevPage) => prevPage + 1);
        setOptionsLocation((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesLocation(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpenLocation = () => {
    setPageLocation(1);
  };

  const handleChangeLocation = (valueLocation) => {
    setValueLocation(valueLocation.value);
    setPageLocation(0);
  };

  const handleInputChangeLocation = (typedLocation) => {
    logValueLocation(typedLocation);
    if (!typedLocation) setPageLocation(0);
  };

  const handleMenuScrollToBottomLocation = () => {
    if (pageLocation < totalPagesLocation) {
      addOptionsLocation();
    }
  };

  const renderOptionLocation = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typedLocation) {
      addOptionsLocation();
    }
  }, [typedLocation]);

  //********Location DDL End  ********//

  const reset = () => {
    setDisplay(false)
    setCityId([]);
    setStartDate(null);
    setEndDate(null);
    setPresent(false);
    setValue(null);
    setValueC(null);
    setJobTypeId(null);
    setWorkLocationId(null);
    setWorkTypeId(null);
    setHeadline("");
    setEmail("");
    setAbout("");
    setIndustryId(null);
    setIndustryName("");
    setCategoryId(null);
    setCompanySizeId(null);
    setTagline("");
    setPublicUrl("");
    setWebsite("");
    setAvgTurnOver("");
    setJobTitle("");
    setDescription("");
    setInsName("");
    setOrganizationName("");
    setGenOrgInstId("");
    setnewOrgType(null);
    setFileName("");
  };
  useEffect(() => {
    if (
      startDate &&
      endDate &&
      moment(endDate).isBefore(moment(startDate), "day")
    ) {
      setEndDate(null);
    }
  }, [startDate, endDate]);
  const [getOrgInsTId, setGenOrgInstId] = useState('');
  const [newOrgType, setnewOrgType] = useState(null);
  const [sync, setSync] = useState(false);
  const AddExperience = async () => {
    setDisplay(true);
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      companyUid: valueC === null ? JSON.stringify(getOrgInsTId) : valueC,
      jobTitle: value,
      positionHeadline: headline,
      jobType: jobTypeId,
      workLocationType: workLocationId,
      workLevelType: workTypeId,
      description: description,
      locationId: null,
      cityId: cityId,
      startDate:
        startDate === null ? null : moment(startDate).format("YYYY-MM-DD"),
      endDate: endDate === null ? null : moment(endDate).format("YYYY-MM-DD"),
      isPresent: present,
      langKey: language === "en" ? "" : language,
    };
    console.log("data22222000000000000", data);

    if (
      // valueC === null ||
      value === null ||
      jobTypeId === null ||
      workLocationId === null ||
      workTypeId === null ||
      cityId === null ||
      startDate === null ||
      (present === false && endDate === null)
    ) {
      setErrorToastMessage(t("modals.Please fill all the required fields"));
      setShowErrorToast(true);
    } else if (!present && isExperienceDateRangeInvalid) {
      setErrorToastMessage("End date cannot be earlier than start date.");
      setShowErrorToast(true);
    } else {
      try {
        await axios
          .post(`UserData/AddWorkExperienceInfo?IsSynced=${sync}`, data)
          .then((resData) => {
            console.log("resData", resData.data.responseData);
            getUserProfile();
            //   toast.success(resData.data.message);
            setToastMessage(resData.data.message);
            setShowToast(true);
            handleCloseUserExperience();
            reset();
          });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
  };

  //********Create Education Start  ********//
  const [CreateCCVExperience, setCreateCCVExperience] = useState(false);
  const handleOpenCreateCCVExperience = () => setCreateCCVExperience(true);
  const handleCloseCreateCCVExperience = () => setCreateCCVExperience(false);

  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [description, setDescription] = useState("");
  const [headline, setHeadline] = useState("");
  const [publicUrl, setPublicUrl] = useState("");
  const [website, setWebsite] = useState("");
  const [tagline, setTagline] = useState("");
  const [about, setAbout] = useState("");
  const [avgTurnOver, setAvgTurnOver] = useState("");
  const [jobTitle, setJobTitle] = useState("");

  const CreateExperience = async () => {
    setDisplay(true);
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      compName: companyName,
      logoImage: "",
      cityId: cityId,
      email: email,
      about: about,
      industryId: IndustryId,
      industryName: IndustryName || "",
      companyCategoryId: CategoryId,
      companySizeId: CompanySizeId,
      tagline: tagline,
      publicUrl: publicUrl,
      website: website,
      backgroudImage: "",
      incorpDate: "",
      avgAnumTurnOver: avgTurnOver,
      jobTitle: jobTitle,
      positionHeadline: headline,
      jobType: jobTypeId,
      workLocationType: workLocationId,
      workLevelType: workTypeId,
      description: description,
      locationId: null,
      startDate: startDate === null ? null : moment(startDate).format("YYYY-MM-DD"),
      endDate: endDate === null ? null : moment(endDate).format("YYYY-MM-DD"),
      isPresent: present,
      langKey: language === "en" ? "" : language,
    };

    console.log("data create exp", data);
    if (
      companyName === "" ||
      IndustryId === null ||
      IndustryId === "" ||
      CompanySizeId === "" ||
      cityId === null ||
      startDate === "" ||
      jobTitle === "" ||
      jobTypeId === null ||
      workLocationId === null ||
      workTypeId === null || email === ''
    ) {
      setErrorToastMessage(t("modals.Please fill all the required fields"));
      setShowErrorToast(true);
    } else {
      try {
        await axios
          .post(`UserData/CreateAndAddWorkExperienceInfo`, data)
          .then((resData) => {
            console.log("resData crt exp", resData.data.responseData);
            getUserProfile();
            //   toast.success(resData.data.message);
            setToastMessage(resData.data.message);
            setShowToast(true);
            handleCloseCreateCCVExperience();
            handleCloseUserExperience();
            reset();
          });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
  };

  //********Create Education End  ********//

  //************************Designation  Start  ************************//
  const [value, setValue] = useState(null);
  const [pageD, setPageD] = useState(0);
  const [typed, setTyped] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [totalPagesDesignation, setTotalPagesDesignation] = useState(0);

  const logValue = debounce((typed) => {
    setTyped(typed);
  }, 250);

  const addOptions = () => {
    setIsLoading(true);
    const fitidParam =
      IndustryId !== null && IndustryId !== undefined && IndustryId !== "" && IndustryId !== 0
        ? `&Fitid=${IndustryId}`
        : "";
    axios
      .get(
        `Master/GetDesignationDDL?DeviceType=Web&search=${typed}&pageNumber=${pageD + 1
        }&pageSize=100&LangKey=${language}${fitidParam}`
      )
      .then((response) => {
        console.log(response);
        const data = response?.data?.responseData?.data;
        // Check if data is an array
        if (Array.isArray(data)) {
          const mappedData = data.map((item) => ({
            value: item.dsgntnId,
            label: item.name,
          }));
          setOptions((prevOptions) => [...prevOptions, ...mappedData]);
        } else {
          console.error("Expected data to be an array, but got:", data);
        }

        setPageD((prevPage) => prevPage + 1);
        setIsLoading(false);
        setTotalPagesDesignation(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  };
  const handleOpen = () => {
    setPageD(1);
  };

  const handleChange = (value) => {
    if (value === null) {
      setValue(null);
    } else {
      setValue(value.label);
    }
  };

  const handleInputChange = (typed) => {
    logValue(typed);
    if (!typed) setPageD(0);
  };

  const handleMenuScrollToBottom = () => {
    if (pageD < totalPagesDesignation) {
      addOptions();
    }
  };

  const renderOption = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typed) {
      addOptions();
    }
  }, [typed]);

  //************************ Designation End  ************************//
  //************************profile headline Start  ************************//

  const [pageP, setPageP] = useState(0);
  const [typedprofile, setTypedprofile] = useState("");
  const [optionsP, setOptionsP] = useState([]);
  const [totalPagesProfile, setTotalPagesProfile] = useState(0);

  const logValue1 = debounce((typedprofile) => {
    setTypedprofile(typedprofile);
  }, 250);

  const addOptionsprofile = (
    searchValue = typedprofile,
    nextPage = pageP + 1,
    shouldReplace = false
  ) => {
    setIsLoading(true);
    const data = {
      pageNumber: nextPage,
      pageSize: 100,
      deviceType: "Web",
    }
    axios
      .post(
        `Master/GetPositionHeadlineDDL?search=${searchValue}&LangKey=${language}`, data
      )
      .then((response) => {
        console.log("response.........", response);
        const data = response?.data?.responseData?.allData;
        // Check if data is an array
        if (Array.isArray(data)) {
          const mappedData = data.map((item, index) => ({
            label: item,
            value: item,
          }));
          console.log("mappedData==>", mappedData)
          setOptionsP((prevOptions) =>
            shouldReplace ? mappedData : [...prevOptions, ...mappedData]
          );
        } else {
          console.error("Expected data to be an array, but got:", data);
        }

        setPageP(nextPage);
        setIsLoading(false);
        setTotalPagesProfile(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  };
  const handleOpenProfle = () => {
    setTypedprofile("");
    setPageP(0);
    setOptionsP([]);
    addOptionsprofile("", 1, true);
  };

  const handleChangeProfile = (value) => {
    if (value === null) {
      setHeadline(null);
    } else {
      setHeadline(value.label);
    }
  };

  const handleInputChangeProfile = (inputValue, actionMeta) => {
    if (actionMeta?.action !== "input-change") {
      return inputValue;
    }

    setPageP(0);
    setOptionsP([]);
    logValue1(inputValue || "");

    if (!inputValue) {
      addOptionsprofile("", 1, true);
    }

    return inputValue;
  };

  const handleHeadlineInputChange = (e) => {
    const nextValue = e.target.value;
    setHeadline(nextValue);

    if (!nextValue.trim()) {
      setShowInputInsteadOfDropdown(false);
      setTypedprofile("");
      setPageP(0);
      setOptionsP([]);
      addOptionsprofile("", 1, true);
    }
  };

  const handleMenuScrollToBottomProfile = () => {
    if (pageP < totalPagesProfile) {
      addOptionsprofile();
    }
  };

  useEffect(() => {
    if (typedprofile) {
      addOptionsprofile(typedprofile, 1, true);
    }
  }, [typedprofile]);

  //************************ profile headline End  ************************//

  //************************Companied DDL Start  ************************//
  const [valueC, setValueC] = useState(null);
  console.log("value", valueC);
  const [pageC, setPageC] = useState(0);
  const [typeC, setTypeC] = useState("");
  const [isLoadingC, setIsLoadingC] = useState(false);
  const [optionsC, setOptionsC] = useState([]);
  const [totalPagesCom, setTotalPagesCom] = useState(0);

  const logValueC = debounce((typeC) => {
    setTypeC(typeC);
  }, 250);

  const Companies = () => {
    setIsLoadingC(true);
    axios
      .get(
        `Master/GetAllCompaniesDDL?search=${typeC}&pageNumber=${pageC + 1
        }&pageSize=100&DeviceType=Web&LangKey=${language}`
      )
      .then((response) => {
        console.log(response);
        const data = response?.data?.responseData?.list.map((item) => ({
          value: item.uiDno,
          label: item.name,
          isOrgVrfd: item.isVerified,
          isOrgRgd: item.isRgstrd,
        }));
        setPageC((prevPage) => prevPage + 1);
        setIsLoadingC(false);
        setOptionsC((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesCom(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingC(false);
      });
  };

  const handleOpenC = () => {
    setPageC(1);
  };

  const handleChangeC = (value) => {
    if (value === null) {
      setValueC(null);
    } else {
      setValueC(value.value);
    }

    setPageC(0);
  };

  const handleInputChangeC = (typed) => {
    logValueC(typed);
    if (!typed) setPageC(0);
  };

  const handleMenuScrollToBottomC = () => {
    if (pageC < totalPagesCom) {
      Companies();
    }
  };

  const renderOptionC = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typeC) {
      Companies();
    }
  }, [typeC]);

  //************************ Companies DDL End  ************************//

  //********Industry DDL Start  ********//
  const [Industry, setIndustry] = useState([]);
  const [IndustryId, setIndustryId] = useState(null);
  const [IndustryName, setIndustryName] = useState("");
  const getIndustryType = () => {
    axios
      .get(`Master/GetFirmIndustryTypeDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.fitid,
          label: item.name,
        }));
        setIndustry(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getIndustryType();
  }, []);
  //********Industry DDL End  ********//

  //********Category DDL Start  ********//
  const [Category, setCategory] = useState([]);
  const [CategoryId, setCategoryId] = useState(null);
  const getCategory = () => {
    axios
      .get(`Master/GetFirmCategoryDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.fcid,
          label: item.name,
        }));
        setCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getCategory();
  }, []);
  console.log("Category", Category);
  //********Category DDL End  ********//

  //********CompanySize DDL Start  ********//
  const [CompanySize, setCompanySize] = useState([]);
  const [CompanySizeId, setCompanySizeId] = useState(null);
  const getCompanySize = () => {
    axios
      .get(`Master/GetFirmSizeDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setCompanySize(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getCompanySize();
  }, []);
  //********CompanySize DDL End  ********//
  const handleCityChange = (selectedOption) => {
    if (selectedOption === null) {
      setCityId(null);
    } else {
      setCityId(selectedOption.value);
    }
  };
  const handleIndustryChange = (selectedOption) => {
    if (selectedOption === null) {
      setIndustryId(null);
      setIndustryName("");
    } else {
      setIndustryId(selectedOption.value);
      setIndustryName(selectedOption.label);
    }
    setValue(null);
    setOptions([]);
    setPageD(0);
    setTyped("");
  };
  const handleCategoryChange = (selectedOption) => {
    if (selectedOption === null) {
      setCategoryId(null);
    } else {
      setCategoryId(selectedOption.value);
    }
  };
  const handleCompanyChange = (selectedOption) => {
    if (selectedOption === null) {
      setCompanySizeId(null);
    } else {
      setCompanySizeId(selectedOption.value);
    }
  };

  // useEffect(() => {
  //   if (showUserExperience || CreateCCVExperience) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [showUserExperience, CreateCCVExperience]);

  //********Job Type List Start  ********//
  const [jobTypeData, setJobTypeData] = useState([]);
  const [jobTypeId, setJobTypeId] = useState(null);
  const getJobType = () => {
    axios
      .get(`Master/GetJobTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        console.log("datadatadata", data);
        setJobTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getJobType();
  }, []);
  //********Job Type List End  ********//

  //********Work Level Type List Start  ********//
  const [workTypeData, setWorkTypeData] = useState([]);
  const [workTypeId, setWorkTypeId] = useState(null);
  const getWorkType = () => {
    axios
      .get(`Master/GetWorkLevelTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getWorkType();
  }, []);
  //********Work Level Type List End  ********//

  //********Work Location Type List Start  ********//
  const [workLocationData, setWorkLocationData] = useState([]);
  const [workLocationId, setWorkLocationId] = useState(null);
  const getWorkLocationType = () => {
    axios
      .get(`Master/GetWorkLocationTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkLocationData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getWorkLocationType();
  }, []);
  //********Work Location Type List End  ********//
  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };

  const [showTooltip, setShowTooltip] = useState(false);
  const [OrganizationName, setOrganizationName] = useState("");
  const [InsName, setInsName] = useState("");
  const targetRef = useRef(null);
  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };

  const handleCloseNewOrg = (e) => {
    e?.preventDefault?.();
    setInsName("");
    setOrganizationName("");
    setGenOrgInstId("");
    setnewOrgType(null);
    setValueC(null);
    setFileName("");
  };

  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };



  const [orgCity, setOrgCity] = useState(null);
  const handleSaveInstitution = async () => {
    // setDisplay(true);

    // const formData = new FormData();
    // formData.append("orgName", OrganizationName);
    // formData.append("OrgType", "UnRegdInstitution");
    // formData.append("CityID", orgCity);
    // formData.append("OrgLogo", fileName);
    // formData.append("sessionId", sessionId);
    // console.log("formData", formData);

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      gnrlOrgName: OrganizationName,
      type: 1,
      cityId: cityId,
      logoImage: fileName,
      locationId: null,
      langKey: language === "en" ? "" : language,
    }

    try {
      const res = await axios.post("/General/AddGeneralOrgByUser", data);
      console.log("resposne new", res);
      setGenOrgInstId(res.data.responseData.id);
      setnewOrgType(res.data.responseData.value);
      setInsName(res.data.responseData.value);
      setShowTooltip(false);
      setOrganizationName("");
      setOrgCity(null);
      setFileName("");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // toast.warning(error.response.data.message);
      } else {
        // toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };
  // console.log("userdata999999999999", userData.viewExperienceInfo);

  function checkResumeExperiences(resumeExperiences) {
    const presentCount = resumeExperiences?.filter(
      (exp) => exp.isPresent === true
    ).length;
    console.log("resumeExperiences", presentCount);
    if (presentCount >= 2) {
      return (
        <p className="warningText mt-1 me-3 ms-3 ">
          <WarningAmberSharpIcon style={{ fontSize: '16px' }} />  {t("User Profile.Warnings")}: {t("User Profile.More than two experiences are marked as present")}
        </p>
      );

    }
  }

  // useEffect(() => {
  //   let scrollY = 0;

  //   if (showUserExperience) {
  //     scrollY = window.scrollY;

  //     // Lock scroll
  //     document.body.style.position = 'fixed';
  //     document.body.style.top = `-${scrollY}px`;
  //     document.body.style.left = '0';
  //     document.body.style.right = '0';
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden'; // 🛠️ Add this line
  //     document.body.classList.add('modal-open');
  //   } else {
  //     // Unlock scroll
  //     const scrollYValue = document.body.style.top;
  //     document.body.style.position = '';
  //     document.body.style.top = '';
  //     document.body.style.left = '';
  //     document.body.style.right = '';
  //     document.body.style.overflow = '';
  //     document.documentElement.style.overflow = ''; // 🛠️ Add this line
  //     document.body.classList.remove('modal-open');

  //     window.scrollTo(0, parseInt(scrollYValue || '0') * -1);
  //   }
  // }, [showUserExperience]);

  // useEffect(() => {
  //   let scrollY = 0;

  //   if (showUserExperience) {
  //     // Save current scroll position
  //     scrollY = window.scrollY;
  //     document.body.dataset.scrollY = scrollY; // store in dataset

  //     // Lock scrolling
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open');
  //   } else {
  //     // Unlock scrolling
  //     document.body.style.overflow = '';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open');

  //     // Restore scroll position
  //     const storedY = document.body.dataset.scrollY || "0";
  //     window.scrollTo(0, parseInt(storedY, 10));
  //   }
  // }, [showUserExperience]);

  const modalContentRef = useRef(null);
  return (
    <>
      {showUserExperience && (
        <Portal layer="modal">
          <div
            className="modal fade show modal-lg wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content" ref={modalContentRef}>
                <div className="setting-header d-flex justify-content-between align-items-center">
                  {/* <h6>Add Experience</h6> */}
                  <div className="d-flex align-items-center settings">
                    <h6 className="mb-0 me-3" >{t("User Profile.Add Experience")}</h6>
                  </div>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-3 pointer"
                    onClick={handleCloseUserExperience}
                  />
                </div>
                <Form>
                  {checkResumeExperiences(userData?.viewExperienceInfo)}

                  <div className="row modal-p settings CreateCompany">
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about" className="wlj-edu-field-label">
                        {t("User Profile.Designation (Job Title)")}
                        <span className="text-danger ms-2">*</span>
                      </label>
                      {showInputInsteadOfDropdown ? (
                        <input
                          type="text"
                          className="Dark-Input-from-group"
                          value={value}
                          onChange={e => setValue(e.target.value)}
                          onBlur={() => {
                            if (value && value.trim()) setShowInputInsteadOfDropdown(false);
                          }}
                          autoFocus
                          isInvalid={display && value === ""}
                        />
                      ) : (
                        <CreatableSelect
                          options={options}
                          styles={customStyles} {...wljSelectPortalProps}
                          classNamePrefix="react-select"
                          placeholder={t("User Profile.Select Designation")}
                          noOptionsMessage={() => t("modals.Search and Select Designation")}
                          onOpen={handleOpen}
                          onChange={selectedOption => {
                            if (!selectedOption) {
                              setValue("");
                            } else {
                              setValue(selectedOption.label);
                              if (typeof selectedOption.label === "string" && isNaN(selectedOption.label)) {
                                setShowInputInsteadOfDropdown(true);
                              }
                            }
                          }}
                          onMenuScrollToBottom={handleMenuScrollToBottom}
                          onInputChange={handleInputChange}
                          isClearable
                          value={options.find(option => option.label === value) || (value ? { label: value, value } : null)}
                          className={display && !value ? "is-invalid" : ""}
                          isValidNewOption={(inputValue, _, selectOptions) =>
                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                          }
                          onCreateOption={inputValue => {
                            setValue(inputValue);
                            setShowInputInsteadOfDropdown(true);
                          }}
                        />
                      )}
                      {display && !value ? (
                        <span className="error_msg_lbl">
                          {t("User Profile.Please Select Designation")} {" "}
                        </span>
                      ) : null}
                    </div>
                    <div className="col-md-6 mt-2">
                      <div className="wlj-edu-label-row d-flex align-items-center">
                        <label htmlFor="about" className="mb-0">
                          {t("User Profile.Company")}<span className="text-danger ms-2">*</span>
                        </label>
                        {InsName !== "" ? (
                          <a
                            href="#"
                            onClick={handleCloseNewOrg}
                            className="createModal f-14 ms-2"
                          >
                            {t("User Profile.Close")}
                          </a>
                        ) : (
                          <a
                            href="#"
                            ref={targetRef}
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTooltip();
                            }}
                            className="createModal f-14 ms-2"
                          >
                            {t("User Profile.Create New")}
                          </a>
                        )}
                      </div>
                      <Overlay
                        target={targetRef.current}
                        show={showTooltip}
                        placement="bottom"
                        rootClose
                        container={document.querySelector(".modal")}
                        onHide={() => setShowTooltip(false)} // Close when clicking outside
                      >
                        <Popover id="popover-basic">
                          <Popover.Header as="h3" className="Dark-Body-Card-group">{t("Sidemenubar.Create Company")}</Popover.Header>
                          <Popover.Body className="Dark-Body-Card-group">
                            <Form>
                              <div>
                                <label className="mb-1 Text-mb-Create">{t("Newsfeed.Company Name")}</label>
                                <input
                                  type="text"
                                  value={OrganizationName}
                                  onChange={(e) => setOrganizationName(e.target.value)}
                                  placeholder={t("User Profile.Enter Company Name")}
                                  className="mb-2 form-control Dark-Input-from-group"
                                />
                              </div>
                              <div>
                                <label className="mb-1 Text-mb-Create">{t("User Profile.City")}</label>
                                <Select
                                  defaultValue={cityId}
                                  onChange={(selectedOption) =>
                                    setCityId(selectedOption.value)
                                  }
                                  options={cityData}
                                  noOptionsMessage={() => t("modals.Search and Select City")}
                                  placeholder={t("modals.Search and Select City")}
                                  onInputChange={(inputValue) => {
                                    setCitySearch(inputValue);

                                  }}
                                  invalid={display && cityId === ""}
                                  styles={customStyles} {...wljSelectPortalProps}
                                  classNamePrefix="react-select"
                                />
                              </div>
                              <div className=" mt-2 mb-2 Text-mb-Create">
                                <label className="mb-1">{t("User Profile.Institute logo")}</label>
                                <input
                                  type="file"
                                  id="lastName"
                                  // className="form-control Dark-Input-from-group"
                                  placeholder=""
                                  onChange={handleFileChange}
                                //   onChange={(e) => {
                                //     handleProfileImageChange(e);
                                //   }}
                                //   invalid={displays && profileImage === ""}
                                />
                                {/* {displays && !profileImage ? (
                          <span className="error_msg_lbl text-red">
                            Upload Image{" "}
                          </span>
                        ) : null} */}
                              </div>
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="closebtn me-2 ms-3"
                                  onClick={() => {
                                    setShowTooltip(false);
                                    setOrganizationName("");
                                  }}
                                  style={{ width: "50px", height: "30px" }}
                                >
                                  {t("User Profile.Close")}
                                </button>

                                <button
                                  type="button"
                                  className="mainBtn"
                                  onClick={handleSaveInstitution}
                                  style={{ height: "30px !important", padding: '0px 11px' }}
                                >
                                  {t("Newsfeed.Save")}
                                </button>
                              </div>
                            </Form>
                          </Popover.Body>
                        </Popover>
                      </Overlay>
                      {InsName !== "" ? (
                        <div className="d-flex align-items-center wlj-org-selected-row">
                          <input
                            type="text"
                            value={InsName}
                            placeholder={t("User Profile.Enter Org name")}
                            className="mb-2 form-control"
                            disabled
                          />
                          <CloseSharpIcon
                            className="material-symbols-sharp pointer ms-2 mb-2"
                            onClick={handleCloseNewOrg}
                            title={t("User Profile.Close")}
                          />
                        </div>
                      ) : (
                        <div className="form-group">
                          <CreatableSelect
                            defaultValue={valueC}
                            options={optionsC}
                            styles={customStyles} {...wljSelectPortalProps}
                            classNamePrefix="react-select"
                            optionRenderer={renderOptionC}
                            placeholder={t("User Profile.Select Company")}
                            noOptionsMessage={() => t("modals.Search and Select Company")}
                            onOpen={handleOpenC}
                            onChange={handleChangeC}
                            onMenuScrollToBottom={handleMenuScrollToBottomC}
                            onInputChange={handleInputChangeC}
                            isClearable
                            // onCreateOption={(newOption) => {
                            //   handleOpenCreateCCVExperience();
                            //   handleCloseUserExperience();
                            // }}
                            className="iconsDropdown"
                            invalid={display && valueC === ""}
                            formatOptionLabel={(option) => (
                              <div>
                                {option.label}

                                {option.isOrgVrfd === true ? (
                                  <img src={resume.verified} width={15} className="ms-1" />
                                ) : option.isOrgRgd === true ? (
                                  <img src={resume.register} width={15} className="ms-1" />
                                ) : (
                                  <img src={resume.unregister} width={15} className="ms-1" />
                                )}
                              </div>
                            )}
                          />
                        </div>
                      )}


                      {display && !valueC && !getOrgInsTId ? (
                        <span className="error_msg_lbl">
                          {/* Please Select Company */}
                          {t("User Profile.Please Select Company")}
                        </span>
                      ) : null}
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="about">
                        {t("User Profile.Profile Headline")}
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      {/* <CreatableSelect
                    options={optionsP}
                    styles={customStyles} {...wljSelectPortalProps}
                    placeholder={"Profile Headline"}
                    noOptionsMessage={() => t("modals.Search and Select Profile Headline")}

                    onMenuOpen={handleOpenProfle}
                    onChange={handleChangeProfile}
                    onMenuScrollToBottom={handleMenuScrollToBottomProfile}
                    onInputChange={handleInputChangeProfile}
                    isClearable
                    isValidNewOption={(inputValue, selectValue, selectOptions) =>
                      !!inputValue && !selectOptions.some(option => option.label === inputValue)
                    }
                    onCreateOption={(inputValue) => {
                      const newOption = { label: inputValue, value: inputValue };
                      setOptionsP((prev) => [...prev, newOption]);
                      setHeadline(inputValue); // directly set the value
                    }}
                    value={headline ? { label: headline, value: headline } : null}
                    
                    invalid={display && headline === ""}
                  /> */}
                      {showInputInsteadOfDropdown ? (
                        <input
                          type="text"
                          className="Dark-Input-from-group"
                          value={headline}
                          onChange={handleHeadlineInputChange}
                          onBlur={() => {
                            if (headline.trim()) {
                              setShowInputInsteadOfDropdown(false);
                            }
                          }}
                          autoFocus
                          isInvalid={display && headline === ""}
                        />
                      ) : (
                        <CreatableSelect
                          options={optionsP}
                          styles={customStyles} {...wljSelectPortalProps}
                          classNamePrefix="react-select"
                          placeholder={t("User Profile.Select Field")}
                          noOptionsMessage={() => t("modals.Search and Select Field")}
                          onMenuOpen={handleOpenProfle}
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              setHeadline(selectedOption.value);
                              setShowInputInsteadOfDropdown(true); // switch to editable input
                            } else {
                              setHeadline("");
                            }
                          }}
                          onMenuScrollToBottom={handleMenuScrollToBottomProfile}
                          onInputChange={handleInputChangeProfile}
                          isClearable
                          isValidNewOption={(inputValue, _, selectOptions) =>
                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                          }
                          onCreateOption={(inputValue) => {
                            const newOption = { label: inputValue, value: inputValue };
                            setOptionsP((prev) => [...prev, newOption]);
                            setHeadline(inputValue);
                            setShowInputInsteadOfDropdown(true); // switch to input after create
                          }}
                          value={headline ? { label: headline, value: headline } : null}
                          className={display && headline === "" ? "is-invalid" : ""}
                        />
                      )}

                      {/* <textarea
                      id="about"
                      name="about"
                      rows="2"
                      cols="50"
                      value={headline}
                      onChange={(e) => setHeadline(e.target.value)}
                    // invalid={display && headline === ""}
                    ></textarea> */}
                      {/* {display && !headline ? (
                      <span className="error_msg_lbl">
                        Please Enter Profile Headline{" "}
                      </span>
                    ) : null} */}
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="about">
                        {t("User Profile.City")}
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <Select
                        defaultValue={cityId}
                        onChange={handleCityChange}
                        options={cityData}
                        noOptionsMessage={() => t("modals.Search and Select City")}
                        placeholder={t("modals.Search and Select City")}
                        onInputChange={(inputValue) => {
                          setCitySearch(inputValue);
                        }}
                        isClearable
                        invalid={display && cityId === ""}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                      />
                      {display && !cityId ? (
                        <span className="error_msg_lbl"> {t("User Profile.Please Select City")} </span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Work Level Type")}<span className="text-danger ms-2">*</span>
                      </label>
                      <Select
                        defaultValue={workTypeId}
                        onChange={(e) => {
                          setWorkTypeId(e.value);
                        }}
                        options={workTypeData}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        isSearchable={false}
                        placeholder={t("Newsfeed.Select Work Level Type")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Work Location Type")}<span className="text-danger ms-2">*</span>
                      </label>
                      <Select
                        defaultValue={workLocationId}
                        onChange={(e) => {
                          setWorkLocationId(e.value);
                        }}
                        isSearchable={false}
                        options={workLocationData}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        placeholder={t("User Profile.Select Work Location Type")}
                      />

                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Employment type (Job Type)")}<span className="text-danger ms-2">*</span>
                      </label>

                      <Select
                        defaultValue={jobTypeId}
                        onChange={(e) => {
                          setJobTypeId(e.value);
                        }}
                        options={jobTypeData}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        isSearchable={false}
                        placeholder={t("User Profile.Select Job Type")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Description")}
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      <textarea
                        id="about"
                        name="about"
                        rows="2"
                        cols="50"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      // invalid={display && description === ""}
                      ></textarea>
                      {/* {display && !description ? (
                      <span className="error_msg_lbl">
                        Please Enter Description{" "}
                      </span>
                    ) : null} */}
                    </div>


                    <div className="col-md-12 mt-2 d-flex align-items-center wlj-is-present-row">
                      <label htmlFor="exp-is-present" className="mb-0">
                        {t("User Profile.Is Present")}
                      </label>
                      <input
                        id="exp-is-present"
                        type="checkbox"
                        style={{ width: "20px", height: "20px", marginLeft: "5px" }}
                        //   id={`check-${item.id}`}
                        //   checked={selectedWorkLevelList.includes(item.id)}
                        onChange={() => setPresent(!present)}
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Start Date")}
                        <span className="text-danger ms-2">*</span>
                      </label>

                      <Flatpickr
                        className="form-control"
                        value={startDate}
                        onChange={(date) => setStartDate(date[0] || null)}
                        id="dob"
                        options={{
                          maxDate: "today", // Disables future dates
                          appendTo: modalContentRef.current || undefined,
                          onReady: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Call the function to stop scroll on year
                          },
                          onOpen: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Also prevent scroll when the picker opens
                          },
                        }}
                      />

                      {display && !startDate ? (
                        <span className="error_msg_lbl">
                          {t("User Profile.Please Select Start Year")}
                        </span>
                      ) : null}
                    </div>

                    {present === true ? '' :
                      <div className="col-md-6 mt-2">
                        <label htmlFor="about">
                          {t("User Profile.End Date")}
                          <span className="text-danger ms-2">*</span>
                        </label>

                        <Flatpickr
                          className="form-control"
                          value={endDate}
                          onChange={(date) => setEndDate(date[0] || null)}
                          id="dob"
                          options={{
                            minDate: startDate || undefined,
                            appendTo: modalContentRef.current || undefined,
                            onReady: (selectedDates, dateStr, instance) => {
                              preventYearScroll(instance); // Call the function to stop scroll on year
                            },
                            onOpen: (selectedDates, dateStr, instance) => {
                              preventYearScroll(instance); // Also prevent scroll when the picker opens
                            },
                          }}
                        />
                        {!present && isExperienceDateRangeInvalid ? (
                          <span className="error_msg_lbl">
                            End date cannot be earlier than start date.
                          </span>
                        ) : null}
                      </div>
                    }


                    <div className="col-md-12 text-end mt-4">
                      <div className="d-flex align-items-center justify-content-end">
                        {UserCcv === "Active" && <>
                          <input
                            type="checkbox"
                            style={{ width: "20px", height: "20px", marginRight: "5px" }}
                            onChange={() => setSync(!sync)}
                            checked={sync}
                          />
                          <label htmlFor="about">
                            {t("User Profile.Sync With Resume")}
                          </label></>}
                        <button
                          type="button"
                          className="closebtn me-2 ms-3"
                          onClick={handleCloseUserExperience}
                          style={{ width: "70px" }}
                        >
                          {t("User Profile.Close")}
                        </button>
                        <button
                          type="button"
                          className="mainBtn1"
                          onClick={AddExperience}
                          style={{ width: "107px" }}
                        >
                          {t("User Profile.Submit")}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Portal>
      )}

      {CreateCCVExperience && (
        <Portal layer="modal">
          <div
            className="modal fade show modal-lg wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="setting-header d-flex justify-content-between align-items-center">
                  <h6>Create Experience</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={handleCloseCreateCCVExperience}
                  />
                </div>
                <Form>
                  <div className="row p-4 settings CreateCompany">
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Company Name<span className="text-danger ms-2">*</span>
                      </label>
                      <input
                        type="text"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        invalid={display && companyName === ""}
                      />
                      {display && !companyName ? (
                        <span className="error_msg_lbl">Enter Company Name </span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Job Title
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <input
                        type="text"
                        value={jobTitle}
                        onChange={(e) => setJobTitle(e.target.value)}
                        invalid={display && jobTitle === ""}
                      />
                      {display && !jobTitle ? (
                        <span className="error_msg_lbl">Enter Job Title </span>
                      ) : null}
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Profile Headline
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      <textarea
                        id="about"
                        name="about"
                        rows="2"
                        cols="50"
                        value={headline}
                        onChange={(e) => setHeadline(e.target.value)}
                      // invalid={display && headline === ""}
                      ></textarea>
                      {/* {display && !headline ? (
                      <span className="error_msg_lbl">
                        Please Enter Profile Headline{" "}
                      </span>
                    ) : null} */}
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Employment type (Job Type)")}<span className="text-danger ms-2">*</span>
                      </label>

                      <Select
                        defaultValue={jobTypeId}
                        onChange={(e) => {
                          setJobTypeId(e.value);
                        }}
                        options={jobTypeData}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        isSearchable={false}
                        placeholder={t("User Profile.Select Job Type")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Work Level Type")}<span className="text-danger ms-2">*</span>
                      </label>
                      <Select
                        defaultValue={workTypeId}
                        onChange={(e) => {
                          setWorkTypeId(e.value);
                        }}
                        options={workTypeData}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        isSearchable={false}
                        placeholder={t("Newsfeed.Select Work Level Type")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Work Location Type")}<span className="text-danger ms-2">*</span>
                      </label>
                      {/* <input type='text' /> */}
                      <Select
                        defaultValue={workLocationId}
                        onChange={(e) => {
                          setWorkLocationId(e.value);
                        }}
                        options={workLocationData}
                        isSearchable={false}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        placeholder={t("User Profile.Select Work Location Type")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        City<span className="text-danger ms-2">*</span>
                      </label>
                      <Select
                        defaultValue={cityId}
                        onChange={handleCityChange}
                        // onChange={(selectedOption) =>
                        //   setCityId(selectedOption.value)
                        // }
                        options={cityData}
                        noOptionsMessage={() => t("modals.Search and Select City")}
                        placeholder={t("modals.Search and Select City")}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        onInputChange={(inputValue) => {
                          setCitySearch(inputValue);
                        }}
                        isClearable
                        invalid={display && cityId === ""}
                      />
                      {display && !cityId ? (
                        <span className="error_msg_lbl">Please Select City </span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Email
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <input
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        invalid={display && email === ""}
                      />
                      {display && !email ? (
                        <span className="error_msg_lbl">Enter Email </span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        About
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      <input
                        type="text"
                        value={about}
                        onChange={(e) => setAbout(e.target.value)}
                      // invalid={display && about === ""}
                      />
                      {/* {display && !about ? (
                      <span className="error_msg_lbl">Enter About </span>
                    ) : null} */}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Industry<span className="text-danger ms-2">*</span>
                      </label>
                      <CreatableSelect
                        closeMenuOnSelect={true}
                        value={
                          IndustryId !== null && IndustryId !== undefined
                            ? {
                              value: IndustryId,
                              label:
                                IndustryName ||
                                Industry.find((o) => o.value === IndustryId)?.label ||
                                "",
                            }
                            : null
                        }
                        onChange={handleIndustryChange}
                        onCreateOption={(inputValue) => {
                          const newOption = { value: 0, label: inputValue };
                          setIndustry((prev) => [...prev, newOption]);
                          setIndustryId(0);
                          setIndustryName(inputValue);
                        }}
                        formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                        options={Industry}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        placeholder={t("User Profile.Select Industry")}
                        isClearable
                      />
                      {display && !IndustryId && IndustryId !== 0 ? (
                        <span className="error_msg_lbl">
                          Please Select Industry{" "}
                        </span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Company Category
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      <Select
                        closeMenuOnSelect={true}
                        defaultValue={CategoryId}
                        onChange={handleCategoryChange}
                        // onChange={(selectedOption) =>
                        //   setCategoryId(selectedOption.value)
                        // }
                        options={Category}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        placeholder={t("User Profile.Select Category")}
                        // invalid={display && CategoryId === ""}
                        isClearable
                      />
                      {/* {display && !CategoryId ? (
                      <span className="error_msg_lbl">
                        Please Select Company Category{" "}
                      </span>
                    ) : null} */}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Company Size<span className="text-danger ms-2">*</span>
                      </label>
                      <Select
                        closeMenuOnSelect={true}
                        defaultValue={CompanySizeId}
                        onChange={handleCompanyChange}
                        // onChange={(selectedOption) =>
                        //   setCompanySizeId(selectedOption.value)
                        // }
                        options={CompanySize}
                        styles={customStyles} {...wljSelectPortalProps}
                        classNamePrefix="react-select"
                        placeholder={t("User Profile.Select CompanySize")}
                        invalid={display && CompanySizeId === ""}
                        isClearable
                      />
                      {display && !CompanySizeId ? (
                        <span className="error_msg_lbl">
                          Please Select Company Size{" "}
                        </span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Public URL
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      <input
                        type="text"
                        value={publicUrl}
                        onChange={(e) => setPublicUrl(e.target.value)}
                      // invalid={display && publicUrl === ""}
                      />
                      {/* {display && !publicUrl ? (
                      <span className="error_msg_lbl">Enter Public URL </span>
                    ) : null} */}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Website
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      <input
                        type="text"
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                      // invalid={display && website === ""}
                      />
                      {/* {display && !website ? (
                      <span className="error_msg_lbl">Enter Website </span>
                    ) : null} */}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        TagLine
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      <input
                        type="text"
                        value={tagline}
                        onChange={(e) => setTagline(e.target.value)}
                      // invalid={display && tagline === ""}
                      />
                      {/* {display && !tagline ? (
                      <span className="error_msg_lbl">Enter TagLine </span>
                    ) : null} */}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Average Turn Over
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      <input
                        type="text"
                        value={avgTurnOver}
                        onChange={(e) => setAvgTurnOver(e.target.value)}
                      // invalid={display && avgTurnOver === ""}
                      />
                      {/* {display && !avgTurnOver ? (
                      <span className="error_msg_lbl">
                        Enter Average Turn Over{" "}
                      </span>
                    ) : null} */}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Description
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>
                      <textarea
                        id="about"
                        name="about"
                        rows="2"
                        cols="50"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      // invalid={display && description === ""}
                      ></textarea>

                    </div>
                    {/* {checkCurrent === false ? <div className="col-md-12 mt-2 d-flex align-items-center"> */}
                    <input
                      type="checkbox"
                      style={{ width: "40px" }}
                      //   id={`check-${item.id}`}
                      //   checked={selectedWorkLevelList.includes(item.id)}
                      onChange={() => setPresent(!present)}
                    />
                    <label htmlFor="about">IsPresent</label>
                    {/* </div> : ''} */}

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Start Year
                        <span className="text-danger ms-2">*</span>
                      </label>

                      <Flatpickr
                        className="form-control"
                        value={startDate}
                        onChange={(date) => setStartDate(date[0] || null)}
                        id="dob"
                        options={{
                          maxDate: "today", // Disables future dates
                          onReady: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Call the function to stop scroll on year
                          },
                          onOpen: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Also prevent scroll when the picker opens
                          },
                        }}
                      />

                      {display && !startDate ? (
                        <span className="error_msg_lbl">
                          Please Select Start Year{" "}
                        </span>
                      ) : null}
                    </div>
                    {present === true ? '' : <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        End Year
                        {/* <span className="text-danger ms-2">*</span> */}
                      </label>

                      <Flatpickr
                        className="form-control"
                        value={endDate}
                        onChange={(date) => setEndDate(date[0] || null)}
                        id="dob"
                        options={{
                          minDate: startDate || undefined,
                          onReady: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Call the function to stop scroll on year
                          },
                          onOpen: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Also prevent scroll when the picker opens
                          },
                        }}
                      />

                      {display && !endDate ? (
                        <span className="error_msg_lbl">
                          Please Select End Year{" "}
                        </span>
                      ) : null}
                      {isExperienceDateRangeInvalid ? (
                        <span className="error_msg_lbl">
                          End date cannot be earlier than start date.
                        </span>
                      ) : null}
                    </div>}


                    {/* <div className="col-md-6 mt-2 d-flex ">
                    <input
                      type="checkbox"
                      style={{ width: "40px" }}
                      //   id={`check-${item.id}`}
                      //   checked={selectedWorkLevelList.includes(item.id)}
                      onChange={() => setPresent(true)}
                    />
                    <label htmlFor="about">IsPresent</label>
                  </div> */}

                    <div className="col-md-12 text-end mt-4">
                      <button
                        type="button"
                        className="mainBtn1"
                        style={{ width: "170px" }}
                        onClick={CreateExperience}
                      >
                        Create Experience
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Portal>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );


};

export default ProfileExperience;
